/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@emotion/css';
import { isEmpty } from 'lodash';
import InputListWidget from './InputListWidget';
import CheckboxWidget from './CheckboxWidget';
import RadioBtnWidget from './RadioBtnWidget';
import { applyFilterBtn, filterBtn } from '../Ui';
import { contentAlignment, mapOrder } from '../../utils';

const filterWrapper = (params) => css`
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: absolute;
  box-sizing: border-box;
  right: 0;
  z-index: 1000;
  margin-top: 6px;
  padding: 15px;
  font-weight: ${params?.fontWeight};
  font-size: ${params?.fontSize};
  color: ${params?.textColor};
  padding: ${params?.padding};
  background: ${params?.backgroundColor};
  width: 100%;
  top: 2.2em;
  ${params?.dropShadow && 'box-shadow: 1px 5px 6px -2px #000000;'}
  border-width: ${params?.borderSize};
  border-color: ${params?.borderColor};
  border-style: solid;
  overflow: hidden;
`;

const categoriesWrapper = (params) => css`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: ${params?.wrap};
  gap: 15px;

  section {
    display: flex;
    justify-content: center;
  }

  section + section {
    border-left: solid 1px ${params?.textColor};
    padding-left: 15px;
  }

  @media (max-width: 940px) {
    flex-wrap: wrap;
  }
`;
const category = (params) => css`
  ${params?.flex && `flex: ${params.flex}`}
`;

const btnSection = (params) => css`
  display: flex;
  justify-content: ${contentAlignment(
  params.reset.buttonAligned,
  params.apply.buttonAligned,
)};
`;

const DropdownMulti = ({
  filters: { multiSelect = [], subscriptions = null, gender = null },
  filtersData = {},
  onChange,
  themeConfig: { multiDropdown, buttons },
  themeConfig,
  isDynamic,
  hasFilterChanged,
  isLoading,
  filterOrder,
  onReset,
}) => {
  const filtersArr = [
    ...(multiSelect.filter((o) => o.options && o.key !== 'subscriptions')),
    ...(gender ? [gender] : []),
    ...(subscriptions ? [subscriptions] : []),
  ];
  const orderedArr = filterOrder?.length ? mapOrder(filtersArr, filterOrder, 'key') : filtersArr;

  return (
    <div className={cx(filterWrapper(multiDropdown), multiDropdown.fontType)}>
      <div className={categoriesWrapper({ wrap: 'nowrap', ...multiDropdown })}>
        {orderedArr?.map((filter) => {
          switch (filter.key) {
            case 'subscriptions':
              return subscriptions && (
                <section
                  key={filter.key}
                  className={category({
                    ...(!orderedArr.length ? { flex: 1 } : {}),
                  })}
                >
                  <CheckboxWidget
                    filter={subscriptions}
                    onChange={onChange}
                    themeConfig={themeConfig}
                  />
                </section>
              );

            case 'gender':
              return gender && (
                <section
                  key={filter.key}
                  className={category({
                    ...(!orderedArr.length ? { flex: 1 } : {}),
                  })}
                >
                  <RadioBtnWidget
                    filter={gender}
                    onChange={onChange}
                    themeConfig={themeConfig}
                  />
                </section>
              );

            default:
              return filter?.options && (
                <section
                  key={filter.key}
                  className={category({ flex: 2 })}
                >
                  <InputListWidget
                    filter={filter}
                    onChange={onChange}
                    hasFiltersData={!isEmpty(filtersData)}
                    isLoading={isLoading}
                    themeConfig={themeConfig}
                  />
                </section>
              );
          }
        })}
      </div>
      <div className={btnSection(buttons)}>
        {(!isDynamic && isEmpty(filtersData)) && (
          <button
            type="button"
            disabled={!hasFilterChanged}
            onClick={onChange(false, false, true)}
            className={cx(
              filterBtn(buttons.apply),
              buttons.apply.fontType,
              applyFilterBtn({
                ...buttons.apply,
                resetAlign: buttons.reset.buttonAligned,
              }),
            )}
          >
            {buttons.apply.label}
          </button>
        )}
        <button
          type="button"
          className={cx(filterBtn(buttons.reset), buttons.reset.fontType)}
          onClick={onReset}
        >
          {buttons.reset.label}
        </button>
      </div>
    </div>
  );
};

DropdownMulti.propTypes = {
  isDynamic: PropTypes.bool,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  filters: PropTypes.object,
  filtersData: PropTypes.object,
  hasFilterChanged: PropTypes.bool,
  themeConfig: PropTypes.object,
  isLoading: PropTypes.bool,
  filterOrder: PropTypes.array,
};

export default DropdownMulti;
